import React from 'react';
import { StyledMultiPartUploadField } from 'modules/components/layer01';
import { FormBaseLayout } from 'modules/components/layer10';
import * as ds from './dataService';

export type SaveMetaPhotoFormProps = {
  id: string;
  handleClose: () => void;
};

export const FC = (props: SaveMetaPhotoFormProps) => {
  const [fnSaveMetaPhotoForm] = ds.useSaveMetaPhoto();
  const form = ds.useFormState(props.id);
  const handleSubmit = async () => {
    const input = {
    };
    await fnSaveMetaPhotoForm(input);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit();
      }}
      ignoreCancel={true}
      successButtonText='Done'
      isLoading={form.formState.isUploading}
    >
      <StyledMultiPartUploadField.FC
        fieldName='apiFileQueue'
        isMultiUpload={true}
        form={form}
        isUploadingFieldName='isUploading'
        uploadCountFieldName='uploadCount'
      />
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
